import React, { Component } from "react";
import * as s from "./LanguageDropdown.module.scss";
import { inject, observer } from "mobx-react";
import { LanguageStore } from "src/stores";
import { Checkbox, Button, P, ModalToolbar } from "..";
import { ISingleWordpressLanguage } from "src/models";
import { tx } from "src/libs/i18n";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  closeButtonText?: string;
  languageStore?: LanguageStore;
}

@inject("languageStore")
@observer
export class LanguageDropdown extends Component<Props> {
  renderCurrentLanguageOption = () => {
    const {
      currentLanguage,
      autoDetectedLanguage,
      defaultLanguage,
      selectedLanguage
    } = this.props.languageStore;
    let selectedLanguageLabel = "";
    let showLanguageLabel = false;
    const language = selectedLanguage ?? currentLanguage;

    if (
      language?.locale === currentLanguage?.locale &&
      language?.locale !== defaultLanguage?.locale
    ) {
      selectedLanguageLabel = tx("languages.selectedLanguage");
      showLanguageLabel = true;
    } else {
      if (language?.locale === autoDetectedLanguage?.locale) {
        selectedLanguageLabel = tx("languages.autodetectedLanguage");
        showLanguageLabel = true;
      } else if (language?.locale === defaultLanguage?.locale) {
        selectedLanguageLabel = tx("languages.defaultLanguage");
        showLanguageLabel = true;
      }
    }

    return (
      <div className={s.selectedLanguageContainer}>
        <Checkbox type="check" selected />
        <P className={s.selectedLanguageName}>{language?.name}</P>
        {showLanguageLabel && (
          <P small className={s.selectedLanguageLabel}>
            {selectedLanguageLabel}
          </P>
        )}
      </div>
    );
  };

  renderLanguageOption = (language: ISingleWordpressLanguage, key) => {
    const {
      currentLanguage,
      setSelectedLanguage,
      autoDetectedLanguage,
      defaultLanguage
    } = this.props.languageStore;
    const { locale, name } = language;

    let selectedLanguageLabel = "";
    let showLanguageLabel = false;
    showLanguageLabel = language?.locale === autoDetectedLanguage?.locale;

    if (
      language.locale === currentLanguage?.locale &&
      language.locale !== defaultLanguage?.locale
    ) {
      selectedLanguageLabel = tx("languages.selectedLanguage");
      showLanguageLabel = true;
    } else if (language.locale === autoDetectedLanguage?.locale) {
      selectedLanguageLabel = tx("languages.autodetectedLanguage");
      showLanguageLabel = true;
    } else if (language.locale === defaultLanguage?.locale) {
      selectedLanguageLabel = tx("languages.defaultLanguage");
      showLanguageLabel = true;
    }

    return (
      <div
        className={s.languageItemContainer}
        key={key}
        onClick={() => setSelectedLanguage(locale)}
      >
        <Checkbox type="check" className={s.checkbox} />
        <P className={s.languageOptionName}>{name}</P>
        {showLanguageLabel && (
          <P small className={s.selectedLanguageLabel}>
            {selectedLanguageLabel}
          </P>
        )}
      </div>
    );
  };

  render() {
    const {
      title,
      closeButtonText,
      languageStore,
      style,
      className,
      children,
      ...rest
    } = this.props;
    const {
      toggleLanguageOverlay,
      selectedLanguage,
      currentLanguage,
      availableLanguages,
      navigateToLanguage
    } = languageStore;

    let languageDropdownContainerClasses = [s.languageDropdownContainer];

    if (className) languageDropdownContainerClasses.push(className);

    return (
      <div
        className={languageDropdownContainerClasses.join(" ")}
        style={style}
        {...rest}
      >
        <ModalToolbar
          title={tx("languages.language")}
          onClose={() => toggleLanguageOverlay()}
        />
        <h3 className={s.overlayTitle}>{title}</h3>
        <div className={s.languageSelectDropdownContainer}>
          {this.renderCurrentLanguageOption(
            selectedLanguage ? selectedLanguage : currentLanguage
          )}
          <div className={s.languageItemsContainer}>
            {availableLanguages.map(this.renderLanguageOption)}
          </div>
          <div className={s.buttonContainer}>
            <Button
              size="medium"
              color="red"
              className={s.searchQueryButton}
              onClick={navigateToLanguage}
            >
              {tx("languages.updateLanguagePreference")}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
